export default __webpack_public_path__ + "static/media/logo.3db22981.png";